import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Store } from 'src/app/core/store/store';
import { filter, take, takeUntil } from 'rxjs/operators';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { User } from 'src/app/shared/models/user.model';
@Component({
  selector: 'app-certificate-share',
  templateUrl: './certificate-share.component.html',
  styleUrls: ['./certificate-share.component.scss']
})
export class CertificateShareComponent extends HandleSubscription implements OnInit {
  public personUrn: any;
  public accessToken: any;
  public files: Array<any> = []
  localFiles: Array<any> = []
  public caption: string = ''
  public postUrlId: any;
  public loader: boolean = false;
  user: User;
  activationInfo: any
  @ViewChild('fileUpload') fileUpload!: ElementRef<HTMLInputElement>;
  constructor(public dashboardService: DashboardService, private store: Store, private route: ActivatedRoute, public router: Router, private toaster: ToastrService) {
    super()
   }

  ngOnInit(): void {
    const navType = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    let imageUrl = localStorage.getItem('certificateImage')
    if(imageUrl) {
      this.localFiles.push(imageUrl)
      this.base64ToFile(imageUrl, 'cetificate.png', 'image/png')
    }
    if (navType.type === 'reload') {
      this.router.navigate(['/']);
      // handle logic here (like resetting state, fetching fresh data, etc.)
    } else {
      this.route.queryParams.subscribe((params: any) => {
        const code = params['code'];
        const state = params['state'];
        const error = params['error'];
        if (code && state) {
          this.getAccessToken(code);
        } else if(!code && !state) {
          this.router.navigate(['/']);
        } else if(error == 'user_cancelled_authorize'){
          this.router.navigate(['/']);
        }
      });
    }

    this.store.select('user').pipe(takeUntil(this.unsubscribe$)).subscribe((user: any) => {
      this.user = user;
    });
    this.store.select('activationInfo').pipe(takeUntil(this.unsubscribe$)).subscribe((activation: any) => {
      if(activation) {
        this.activationInfo = activation
      }
    });
  }

  getAccessToken(code: string) {
    let opts = {
      code: code
    }
    this.dashboardService.getLinkedinToken(opts).subscribe((res: any) => {
      this.personUrn = res.data.userId
      this.accessToken = res.data.accessToken
    })
  }

  base64ToFile(base64, filename, mimeType) {
    const byteString = atob(base64.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeType });
    const file = new File([blob], filename, { type: mimeType });
    // console.log(file, 'filefile')
    this.files.push(file)
    return file;
  }
  

  onFileSelect(event) {
    const input = event.target as HTMLInputElement;
    // this.files = []
    // this.localFiles = []
    const files = Array.from(input.files);
    if (files.length + this.files.length > 5) {
      this.toaster.error('You can select upto 4 image.')
      return;
    }
    Array.from(input.files).forEach(file => {
      this.files.push(file)
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const result = e.target?.result as string;
        this.localFiles.push(result);
      };
      reader.readAsDataURL(file); // convert to base64
    });
  }

  deleteImage(index) {
    this.localFiles = this.localFiles.filter((x, i) => i != index);
    this.files = this.files.filter((x, i) => i != index);
    if (this.files.length === 0) {
      this.fileUpload.nativeElement.value = '';
    }
  }

  submitPost() {
    this.loader =true
    const formData = new FormData();
    formData.append("linkedInAuthToken", this.accessToken);
    formData.append("userId", this.personUrn);
    formData.append('caption', this.caption)
    for (let i = 0; i < this.files.length; i++) {
      formData.append("files", this.files[i]); // use "images[]" as key for multiple
    }
   
    this.dashboardService.postMultiImageLinkedin(formData).subscribe(res => {
      this.postUrlId = res.data.id
      this.loader = false
      if(this.user && this.activationInfo) {
        this.linkedinAnylytics("POST")
      }
    }, error => {
      this.loader = false
    })
  }

  linkedinAnylytics(method) {
    let opts = {
      "firstName": this.user?.firstName,
      "lastName": this.user?.lastName,
      "email": this.user?.email,
      "organization": this.user?.organization,
      "programTemplateName": this.activationInfo?.programTemplateName,
      "method": 'Linkedin',
      "type": method,
      "date": new Date(),
      "photoCount": this.files.length,
      "postId": this.postUrlId
    }
    this.dashboardService.linkedinAnylytics(opts).subscribe(res => {

    })
  }

  ngOnDestroy() {
    localStorage.removeItem('certificateImage')
  }

}
